import JSZip from "jszip";
import { saveAs } from "file-saver";
import { CONFIGURATIONS } from "../config/envConfig";
import showToast from "./toastNotifications";

// Helper to download a file with XHR and progress callback
function downloadWithProgress(url, token, onFileProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";

    xhr.setRequestHeader("Authorization", `Bearer ${token}`);

    xhr.onprogress = (event) => {
      if (event.lengthComputable && typeof onFileProgress === "function") {
        const percent = Math.floor((event.loaded / event.total) * 100);
        onFileProgress(percent);
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        const disposition = xhr.getResponseHeader("Content-Disposition");
        let filename = "default_filename.mp3";
        if (disposition && disposition.includes("filename=")) {
          const matches = disposition.match(/filename="([^"]+)"/);
          if (matches && matches[1]) {
            filename = matches[1];
          }
        }
        resolve({ blob: xhr.response, filename });
      } else {
        reject(new Error(`HTTP error! status: ${xhr.status}`));
      }
    };

    xhr.onerror = () => reject(new Error("Network error during download"));
    xhr.send();
  });
}

export async function downloadMp3Zip(
  crateItems,
  setProgress,
  doGetSignedUrl,
  doIncreaseDownloadCount
) {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const year = now.getFullYear();

  const formattedDate = `${month}-${day}-${year}`;
  const zipName = `supremeedits_${formattedDate}`;
  const zip = new JSZip();

  for (let i = 0; i < crateItems.length; i++) {
    setProgress((i / crateItems.length) * 100);
    const file = crateItems[i];
    try {
      const downloadUrl = file.version.audioFile.replace(
        "/play/",
        "/download/"
      );
      const signedUrlData = await doGetSignedUrl({ path: downloadUrl });
      console.log("signed url", signedUrlData);

      if (!signedUrlData?.response?.data?.url) {
        showToast("error", "Failed to fetch the signed URL.");
      }
      const signedUrl = signedUrlData?.response?.data?.url;
      const token = CONFIGURATIONS.UPLOAD_API_KEY;

      console.log(`Downloading ${i + 1}/${crateItems.length}: ${signedUrl}`);

      const { blob, filename } = await downloadWithProgress(signedUrl, token, (progress) => {
        // console.log(`File ${i + 1} progress: ${progress/crateItems.length}%`);
        setProgress((prev) => (i / crateItems.length * 100) + (progress/crateItems.length));
      });

      zip.file(filename, blob);

      if (file.trackId && file.version?.id) {
        await doIncreaseDownloadCount({
          trackId: file.trackId,
          editId: file.editId,
          remixerId: file.remixerId ? file.remixerId : null,
          versionId: file.version?.id,
        });
      }

    } catch (err) {
      showToast("error", "Failed to process : "+ file.trackTitle + " - " + file.editTitle );
      console.error("Failed to process file:", file, err);
      return false;
    }

    
  }

  zip.generateAsync({ type: "blob" }).then((blob) => {
    saveAs(blob, zipName);
  });

  return true;
}
